module.exports = __webpack_public_path__ + "static/media/chile.f93bf41e.png";